import { call, put, take } from 'redux-saga/effects'
import { eventChannel } from 'redux-saga'
import firebase from '../config/firebase'
import { PartnerTypes } from '../reducers/partnerReducer'

export function* savePartner({ params, callback = () => {} }) {
  const databaseRef = firebase.database().ref()
  const updates = {}

  updates[`partners/${params.tel}/tel`] = params.tel
  updates[`partners/${params.tel}/agreed`] = true
  updates[`partners/${params.tel}/verified`] = true
  updates[`partners/${params.tel}/family_name`] = params.familyName
  updates[`partners/${params.tel}/first_name`] = params.firstName
  updates[`partners/${params.tel}/branch`] = params.selectedBranch
  updates[`partners/${params.tel}/branch_name`] = params.branchName
  updates[`partners/${params.tel}/restaurant`] = params.selectedRestaurant
  updates[`partners/${params.tel}/restaurant_name`] = params.restoName

  try {
    yield call([databaseRef, databaseRef.update], updates)
    yield put({ type: PartnerTypes.SAVE_PARTNER_SUCCESS })
    yield call(callback)
  } catch (e) {
    alert(e)
    yield put({ type: PartnerTypes.SAVE_PARTNER_SUCCESS })
  }
}

export function* fetchPartner({ id }) {
  try {
    const partnerRef = firebase.database().ref(`/partners/${id}`)
    const response = yield call([partnerRef, partnerRef.once], 'value')

    if (response.val() !== null) {
      yield put({
        type: PartnerTypes.FETCH_PARTNER_SUCCESS,
        partner: { ...response.val(), key: id },
      })
    } else {
      yield put({ type: PartnerTypes.FETCH_PARTNER_ERROR, error: 'null' })
    }
  } catch (error) {
    yield put({ type: PartnerTypes.FETCH_PARTNER_ERROR, error })
  }
}

const observerEvent = ref => {
  const listener = eventChannel(emit => {
    ref.on('value', data => {
      if (data.val() !== null) {
        const partners = {}
        data.forEach(res => {
          partners[res.key] = res.val()
        })
        emit(partners)
      } else {
        emit({})
      }
    })

    return () => {
      ref.off()
    }
  })

  return listener
}

export function* fetchPartners() {
  const database = firebase.database()
  const partnersConnectionRef = database.ref('/partners').orderByChild('restaurant')
  const databaseEventChannel = yield call(observerEvent, partnersConnectionRef) // listening databaseEvent
  try {
    while (true) {
      const partners = yield take(databaseEventChannel) // take event data
      yield put({ type: PartnerTypes.FETCH_PARTNERS_CONNECTED, data: partners })
    }
  } catch (error) {
    yield put({ type: PartnerTypes.FETCH_PARTNERS_ERROR, error })
  } finally {
    databaseEventChannel.close()
  }
}



// WEBPACK FOOTER //
// ./src/sagas/partnerSaga.js